<script setup lang="ts">
import {computed, nextTick, ref, watch} from "vue";
import {useRoute} from "vue-router";
import {useToast} from "primevue/usetoast";
import AdminLayout from "./Layouts/AdminLayout.vue";
import GuestLayout from "@/Layouts/GuestLayout.vue";
import UserLayout from "@/Layouts/UserLayout.vue";
import {Toast} from "./Components/Library";
import {useMainStore} from "@/Stores/store";
import {useSessionStorage} from "@vueuse/core";

const $store = useMainStore();
const route = useRoute();
const $toast = useToast();
const $user = useSessionStorage("user", null);
const layouts = {
    default: UserLayout,
    admin: AdminLayout,
    guest: GuestLayout,
};

const layout = computed(() => {
    if (!$store?.user?.id) {
        return "guest";
    }
    return route.meta.layout ?? "default";
});
const toastPosition = ref(null);

watch($store?.toastMessages, async () => {
    if ($store?.toastMessages.length) {
        let message = $store.toastMessages.pop();
        // toastPosition.value = message.position;
        await nextTick();
        $toast.add(message);
        // await nextTick();
        // toastPosition.value = null;
    }
});
</script>
<template>
    <component :is="layouts[layout]">
        <RouterView v-slot="{Component, route}">
            <component :is="Component" />
            <!--            <transition :name="route.meta.transition">-->
            <!--            </transition>-->
        </RouterView>
        <Toast dusk="toast" :position="toastPosition ?? 'bottom-center'" />
    </component>
</template>
<style scoped>
.slide-left-enter-active,
.slide-left-leave-active {
    width: 100vw;
    transition: all 0.2s ease-out;
}

.slide-left-enter-to {
    width: 100vw;
    position: absolute;
    right: 0;
}

.slide-left-enter-from {
    width: 100vw;
    position: absolute;
    right: -100%;
}

.slide-left-leave-to {
    width: 100vw;
    position: absolute;
    left: -100%;
}

.slide-left-leave-from {
    width: 100vw;
    position: absolute;
    left: 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
    width: 100vw;
    transition: all 0.2s ease-out;
}

.slide-right-enter-to {
    width: 100vw;
    position: absolute;
    right: 0;
}

.slide-right-enter-from {
    width: 100vw;
    position: absolute;
    right: -100%;
}

.slide-right-leave-to {
    width: 100vw;
    position: absolute;
    left: -100%;
}

.slide-right-leave-from {
    width: 100vw;
    position: absolute;
    left: 0;
}
</style>
